import { Collapse, CollapseProps, theme } from 'antd';
import styles from './index.module.less';
import { CSSProperties, useEffect, useMemo } from 'react';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CommonBackContent } from '@/components/Layouts/CommonBackContent';
import Link from 'next/link';
import { getFaqDataList } from './FaqData';

const FAQContent = ({ isFromHome = false }: { isFromHome?: boolean }) => {
  const { t } = useTranslation('common');
  const { token } = theme.useToken();
  const { isBlogWeb } = useConfigProvider();
  const router = useRouter();

  // 使用抽离的FAQ数据
  const dataList = useMemo(() => {
    const faqList = getFaqDataList(t);

    // 处理包含链接的FAQ项目
    return faqList.map((item, index) => {
      if (index === 2) {
        // "Can I Still View Instagram Stories After 24 Hours?" 项目
        return {
          ...item,
          children: (
            <>
              <span>
                {t(
                  `Yes! With DolphinRadar's Free Anonymous Story Viewer, you can watch Instagram Stories posted within the past 24 hours—no login required. If you want to track and download Stories from an account over time, consider exploring our`
                )}
              </span>{' '}
              <Link style={{ color: '#725CFF' }} href="/plan">
                {t(`subscription plans`)}
              </Link>{' '}
              <span>{t(`for unlimited access and advanced features. Stay updated and never miss a Story again!`)}</span>
            </>
          ),
        };
      }

      if (index === 6) {
        // "Does this work for Threads too?" 项目
        return {
          ...item,
          children: (
            <>
              <span>
                {t(
                  `No, this viewer is for Instagram only. If you're looking to download media from Threads posts, check out our`
                )}
              </span>{' '}
              <Link style={{ color: '#725CFF' }} href="/threads-downloader">
                {t(`Threads Downloader`)}
              </Link>
              {' — '}
              <span>{t(`it's fast and 100% free.`)}</span>
            </>
          ),
        };
      }

      return item;
    });
  }, [t]);

  useEffect(() => {
    if (isBlogWeb) {
      router.push('/instagram-tracking-blog');
    }
  }, []);

  const panelStyle: React.CSSProperties = {
    marginBottom: 24,
    background: '#FFF',
    borderRadius: token.borderRadiusLG,
    border: 'none',
    color: 'red',
    boxShadow: `0 0 10px #E3E6F3`,
  };

  const getItems: (panelStyle: CSSProperties) => CollapseProps['items'] = (panelStyle) => {
    let tempList;
    tempList = dataList;

    return tempList.map((item, index) => {
      return {
        label: item?.label,
        children:
          typeof item?.children === 'string' ? (
            <p dangerouslySetInnerHTML={{ __html: item?.children }} />
          ) : (
            item?.children
          ),
        key: `${index}`,
        style: panelStyle,
      };
    });
  };

  const getContent = useMemo(() => {
    return (
      <CommonBackContent>
        <div className={styles.content}>
          <div className={styles.topContainer}>
            {isFromHome ? (
              <h2>{t("Frequently Asked Questions about Dolphin Radar's Instagram Story Viewer")}</h2>
            ) : (
              <h1>{t('FrequentlyAskedQuestions')}</h1>
            )}
          </div>

          <Collapse
            className={styles.collapseContent}
            bordered={false}
            items={getItems(panelStyle)}
            defaultActiveKey={undefined}
          />
        </div>
      </CommonBackContent>
    );
  }, [getItems]);

  if (isBlogWeb) {
    return <></>;
  }
  return <>{getContent}</>;
};

export default FAQContent;
